import React, { useState } from 'react'
import {AdvancedMarker, APIProvider, Map, InfoWindow, useAdvancedMarkerRef} from '@vis.gl/react-google-maps';
/*import {Light, Dark} from '../../../styles/MapThemes'*/
import { FaCircle } from "react-icons/fa";
/*const API_KEY = process.env.REACT_GOOGLE_MAPS_2;*/
import { useNavigate } from 'react-router-dom';


function MapComponent({
  theme,
  devices,
  center
}) {
  const position = {lat: -33.458093731460906, lng: -61.48637037692409};
  const mapCenter = center ? { lat: center.lat, lng: center.lng } : position;
  const navigate = useNavigate();
  const [selectedDevice, setSelectedDevice] = useState(null);

  const colors = [
    {
      background: 'rgba(255, 58, 48, 0.843)',
      border: '2px solid #CC0000'
    },
    {
      background: 'rgb(251, 188, 4)',
      border: '2px solid #CCCC00'
    },
    {
      background: 'rgb(52, 199, 89)',
      border: '2px solid #00CC00'
    },
  ]

  return (
    <APIProvider apiKey={'AIzaSyCWSucP_eowjjieK8cPdlkqRkbzKNZ2HW0'}>
      <Map defaultCenter={mapCenter} defaultZoom={13} mapId="478d4c34fa170c81b35be8d5" gestureHandling={'greedy'} disableDefaultUI={true}>
        {devices.map(device => {
          const color = colors[device.status] || colors[0];

          return (
            <DeviceMarker
              key={device.id}
              device={device}
              color={color}
              selectedDevice={selectedDevice}
              setSelectedDevice={setSelectedDevice}
              navigate={navigate}
            />
          );
        })}
      </Map>
    </APIProvider>
    /*<APIProvider apiKey={'AIzaSyCWSucP_eowjjieK8cPdlkqRkbzKNZ2HW0'}>
        <Map
          defaultCenter={{ lat: -34.6, lng: -58.38 }}
          defaultZoom={13}
          mapTypeId='roadmap'
          styles={ theme==='light' ? Light : Dark }
          gestureHandling={'greedy'}
          disableDefaultUI={true}>
        </Map>
    </APIProvider>*/
  )
}

function DeviceMarker({
  device,
  color,
  selectedDevice,
  setSelectedDevice,
  navigate
}) {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const open = selectedDevice === device.id;

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={{ lat: device.lat, lng: device.lng }}
        onClick={() => setSelectedDevice(device.id)}
      >
        <FaCircle style={{ color: color.background }} />
      </AdvancedMarker>

      {open && marker && (
        <InfoWindow
          anchor={marker}
          onCloseClick={() => setSelectedDevice(null)}
        >
          <div>
            <strong onClick={() => navigate(`/home/devices/${device.hwid}`)} style={{cursor:'pointer', color:'blue'}}> {device.hwid} </strong>
            <br />
            Estado: {device.status === 0 ? 'Inactivo' : device.status === 1 ? 'Alerta' : 'Activo'}
          </div>
        </InfoWindow>
      )}
    </>
  );
}

export default MapComponent